module.exports = __webpack_public_path__ + "media/react/assets/Delete-865bb297e9dcc9615d985e61384bd870.svg";